module.exports = __webpack_public_path__ + "img/icon-menu.e62ea361.svg";